<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { required } from "vuelidate/lib/validators";
import { Carousel, Slide } from "vue-carousel";
import { cloneDeep } from "lodash";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import Multiselect from "vue-multiselect";
import groupBy from "lodash/groupBy";
import Details from "@/router/views/dts/dts-modal/details";
import Logs from "@/router/views/dts/dts-modal/logs";
import ManageDu from "@/router/views/dts/dts-modal/process-type-du.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  page: {
    title: "Process Types"
  },
  components: {
    Layout,
    PageHeader,
    Carousel,
    Slide,
    MaskedInput,
    Multiselect,
    Details,
    Logs,
    ManageDu,
    PrintOptions,
    RawData
  },
  data() {
    return {
      title: "Assigned Process Types",
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Assigned Process Types",
          active: true
        }
      ],
      tableData: [],
      filter: "",
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      loading: false,
      slideIndex: 0,
      tabIndex: 0,
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false
      }),
      submitted: false,
      modalTitle: "",
      form: {
        officeId: 0,
        processName: "",
        easeOfDoingBusinessType: "",
        estimatedWorkingDays: "",
        daysToRemindOfficeProcessor: "",
        parentProcessTypeId: 0
      },
      easeOfDoingBusiness: null,
      easeOfDoingBusinessOptions: [
        {
          option: "Simple Process",
          easeOfDoingBusinessType: "Simple Process",
          estimatedWorkingDays: "3",
          daysToRemindOfficeProcessor: "2"
        },
        {
          option: "Complex Process",
          easeOfDoingBusinessType: "Complex Process",
          estimatedWorkingDays: "7",
          daysToRemindOfficeProcessor: "6"
        },
        {
          option: "Highly Technical Process",
          easeOfDoingBusinessType: "Highly Technical Process",
          estimatedWorkingDays: "20",
          daysToRemindOfficeProcessor: "19"
        },
        {
          option: "Highly Technical/Discretional Process",
          easeOfDoingBusinessType: "Highly Technical/Discretional Process",
          estimatedWorkingDays: "20",
          daysToRemindOfficeProcessor: "19"
        },
        {
          option: "Others",
          easeOfDoingBusinessType: "",
          estimatedWorkingDays: "",
          daysToRemindOfficeProcessor: ""
        }
      ],
      maxEstimatedWorkingDays: 0,
      maxDaysToRemindOfficeProcessor: 0,
      itemSelected: null,
      selectedCampus: this.$store.state.data.selectedCampus,
      selectedDU: this.$store.state.data.selectedDU.id,
      selectedDepartment: this.$store.state.data.selectedDepartment.id
    };
  },
  validations: {
    form: {
      processName: { required },
      easeOfDoingBusinessType: { required },
      estimatedWorkingDays: { required },
      daysToRemindOfficeProcessor: { required }
    }
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (item.processName) {
            if (
              item.processName.toUpperCase().includes(this.filter.toUpperCase())
            )
              return item.processName
                .toUpperCase()
                .includes(this.filter.toUpperCase());
          }
          if (item.easeOfDoingBusinessType) {
            if (
              item.easeOfDoingBusinessType
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            )
              return item.easeOfDoingBusinessType
                .toUpperCase()
                .includes(this.filter.toUpperCase());
          }
        });
      }
      return this.groupProcessType(data).sort(function(a, b) {
        if (a.processName < b.processName) {
          return -1;
        }
        if (a.processName > b.processName) {
          return 1;
        }
        return 0;
      });
    },
    paginated() {
      let data = this.filtered;
      var total = this.currentPage * this.perPage;
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      return this.filtered.length;
    }
  },
  created() {
    this.changeCampus();
  },
  methods: {
    changeCampus() {
      this.campusId = this.$store.state.data.selectedCampus.id;
      this.selectedDU = this.$store.state.data.selectedDU.id;
      this.getAssignedProcessType();
      // if (this.tabIndex == 0) {
      //   this.getAssignedProcessType();
      // } else if (this.tabIndex == 1) {
      //   this.getMyProcessType();
      // }
    },
    getAssignedProcessType() {
      this.loading = true;
      if (this.slideIndex == 1) {
        this.slideIndex = 0;
        this.tableData = [];
        this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
      }
      this.$store
        .dispatch("dtsprocesstype/GetProcessTypeByDU", this.selectedDU)
        .then((res) => {
          this.tableData = res.data;
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting processes!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    getTracks(props) {
      this.loading = true;
      this.$store
        .dispatch("dtstrack/GetTrackByProcessTypeId", {
          processTypeId: props.id,
          deliveryUnitId: this.selectedDU,
          departmentId: 0
        })
        .then((res) => {
          this.tableData = res.data.reverse();
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast("Something went wrong - Getting tracks!", "error");
          }
          this.loading = false;
        });
    },
    getMyProcessType() {
      this.loading = true;
      this.$store
        .dispatch("dtsprocesstype/GetMyProcessType", this.selectedDU)
        .then((res) => {
          this.tableData = res.data;
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting processes!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    groupProcessType(props) {
      var parents = props.filter((item) => {
        return item.parentProcessTypeId == null;
      });
      var children = props.filter((item) => {
        return item.parentProcessTypeId != null;
      });
      var groupedChildren = [];
      var x = groupBy(children, "parentProcessTypeId");
      for (const key in x) {
        groupedChildren.push({
          id: x[key][0].parentProcessType.id,
          processName: x[key][0].parentProcessType.processName,
          estimatedWorkingDays:
            x[key][0].parentProcessType.estimatedWorkingDays,
          easeOfDoingBusinessType:
            x[key][0].parentProcessType.easeOfDoingBusinessType,
          daysToRemindOfficeProcessor:
            x[key][0].parentProcessType.daysToRemindOfficeProcessor,
          childProcessTypes: x[key]
        });
      }
      var filteredParents = parents.filter((item) => {
        var count = 0;
        for (var counter = 0; counter < groupedChildren.length; counter++) {
          if (groupedChildren[counter].id == item.id) {
            count++;
          }
        }
        return count == 0;
      });
      var processArray = filteredParents.concat(groupedChildren);
      processArray.forEach((item) => {
        item.showSubtype = false;
        item.isAssigned = props.find((x) => x.id == item.id) ? true : false;
      });
      return processArray;
    },
    showTracks(props) {
      this.slideIndex = 1;
      this.tableData = [];
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
      this.getTracks(props);
    },
    returnToTable() {
      this.slideIndex = 0;
      this.tableData = [];
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
      this.getAssignedProcessType();
    },
    viewDetails(id) {
      this.$refs.details.getData(id);
    },
    viewLogs(id) {
      this.$refs.logs.getData(id);
    },
    manageOffices(props) {
      this.$refs.managedu.getDU(props);
      this.$bvModal.show("modal-processDu");
    },
    onAddProcessType() {
      this.submitted = true;
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      if (this.form.id) {
        this.$store
          .dispatch("dtsprocesstype/UpdateProcessType", this.form)
          .then((res) => {
            this.getMyProcessType();
            this.$bvModal.hide("modal-create-processType");
            this.showToast("Successfully updated!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      } else {
        this.$store
          .dispatch("dtsprocesstype/CreateProcessType", this.form)
          .then((res) => {
            this.onAddDuAccess(res.data.id);
            this.tableData.push(res.data);
            this.$bvModal.hide("modal-create-processType");
            this.showToast("Successfully created!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      }
    },
    addProcessType() {
      this.onReset();
      this.modalTitle = "Create Process Type";
      this.$bvModal.show("modal-create-processType");
    },
    updateProcessType(props) {
      this.onReset();
      this.form = cloneDeep(props);
      this.form.estimatedWorkingDays = this.form.estimatedWorkingDays.toString();
      this.form.daysToRemindOfficeProcessor = this.form.daysToRemindOfficeProcessor.toString();
      this.easeOfDoingBusiness = {
        option:
          this.form.easeOfDoingBusinessType == "Simple Process"
            ? "Simple Process"
            : this.form.easeOfDoingBusinessType == "Complex Process"
            ? "Complex Process"
            : this.form.easeOfDoingBusinessType == "Highly Technical Process"
            ? "Highly Technical Process"
            : this.form.easeOfDoingBusinessType ==
              "Highly Technical/Discretional Process"
            ? "Highly Technical/Discretional Process"
            : "Others",
        easeOfDoingBusinessType:
          this.form.easeOfDoingBusinessType == "Simple Process"
            ? "Simple Process"
            : this.form.easeOfDoingBusinessType == "Complex Process"
            ? "Complex Process"
            : this.form.easeOfDoingBusinessType == "Highly Technical Process"
            ? "Highly Technical Process"
            : this.form.easeOfDoingBusinessType ==
              "Highly Technical/Discretional Process"
            ? "Highly Technical/Discretional Process"
            : this.form.easeOfDoingBusinessType,
        estimatedWorkingDays: this.form.estimatedWorkingDays.toString(),
        daysToRemindOfficeProcessor: this.form.daysToRemindOfficeProcessor.toString()
      };
      this.modalTitle = "Update Process Type";
      this.$bvModal.show("modal-create-processType");
    },
    onAddProcessSubtype() {
      this.submitted = true;
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      if (this.form.id) {
        this.$store
          .dispatch("dtsprocesstype/UpdateProcessType", this.form)
          .then((res) => {
            this.getMyProcessType();
            this.$bvModal.hide("modal-create-processSubtype");
            this.showToast("Successfully updated!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      } else {
        this.$store
          .dispatch("dtsprocesstype/CreateProcessType", this.form)
          .then((res) => {
            this.onAddDuAccess(res.data.id);
            this.itemSelected.childProcessTypes.push(res.data);
            this.$bvModal.hide("modal-create-processSubtype");
            this.showToast("Successfully created!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      }
    },
    addProcessSubtype(props) {
      this.onReset();
      this.itemSelected = props;
      this.form.easeOfDoingBusinessType = props.easeOfDoingBusinessType;
      this.form.parentProcessTypeId = props.id;
      this.maxEstimatedWorkingDays = this.getMaxEstimatedWorkingDays(props);
      this.maxDaysToRemindOfficeProcessor = this.getMaxDaysToRemindOfficeProcessor(
        props
      );
      this.modalTitle = "Create Process Subype";
      this.$bvModal.show("modal-create-processSubtype");
    },
    updateProcessSubtype(props, parent) {
      this.onReset();
      this.form = cloneDeep(props);
      this.form.easeOfDoingBusinessType = props.easeOfDoingBusinessType;
      this.maxEstimatedWorkingDays = this.getMaxEstimatedWorkingDays(parent);
      this.maxDaysToRemindOfficeProcessor = this.getMaxDaysToRemindOfficeProcessor(
        parent
      );
      this.modalTitle = "Update Process Subtype";
      this.$bvModal.show("modal-create-processSubtype");
    },
    onAddDuAccess(id) {
      this.$store.dispatch("dtsprocesstype/AddProcessTypeDU", {
        id: id,
        array: [{ id: this.selectedDU }]
      });
    },
    deleteProcessType(props, itemSelected) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtsprocesstype/DeleteProcessType", props.id)
            .then((res) => {
              if (itemSelected) {
                var childIndex = itemSelected.childProcessTypes.findIndex(
                  (item) => item.id == props.id
                );
                itemSelected.childProcessTypes.splice(childIndex, 1);
                this.$forceUpdate();
              } else {
                var parentIndex = this.tableData.findIndex(
                  (item) => item.id == props.id
                );
                this.tableData.splice(parentIndex, 1);
              }
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    onReset() {
      this.submitted = false;
      this.form = {
        officeId: this.selectedDU,
        processName: "",
        easeOfDoingBusinessType: "",
        estimatedWorkingDays: "",
        daysToRemindOfficeProcessor: "",
        parentProcessTypeId: 0
      };
      this.easeOfDoingBusiness = null;
      this.itemSelected = null;
    },
    getMaxEstimatedWorkingDays(props) {
      if (props.childProcessTypes) {
        var count = 0;
        props.childProcessTypes.forEach((item) => {
          count = count + item.estimatedWorkingDays;
        });
        if (this.form.id) {
          var index = props.childProcessTypes.findIndex(
            (item) => item.id == this.form.id
          );
          count = count - props.childProcessTypes[index].estimatedWorkingDays;
        }
        return props.estimatedWorkingDays - count;
      }
      return props.estimatedWorkingDays;
    },
    getMaxDaysToRemindOfficeProcessor(props) {
      if (props.childProcessTypes) {
        var count = 0;
        props.childProcessTypes.forEach((item) => {
          count = count + item.daysToRemindOfficeProcessor;
        });
        if (this.form.id) {
          var index = props.childProcessTypes.findIndex(
            (item) => item.id == this.form.id
          );
          count =
            count - props.childProcessTypes[index].daysToRemindOfficeProcessor;
        }
        return props.daysToRemindOfficeProcessor - count;
      }
      return props.daysToRemindOfficeProcessor;
    },
    checkEstimatedWorkingDays() {
      if (
        parseFloat(this.form.estimatedWorkingDays) >
        parseFloat(this.maxEstimatedWorkingDays)
      ) {
        this.form.estimatedWorkingDays = this.maxEstimatedWorkingDays;
      } else if (
        this.form.estimatedWorkingDays == "" ||
        parseFloat(this.form.estimatedWorkingDays) < 0
      ) {
        this.form.estimatedWorkingDays = 0;
      }
    },
    checkDaysToRemindOfficeProcessor() {
      if (
        parseFloat(this.form.daysToRemindOfficeProcessor) >
        parseFloat(this.maxDaysToRemindOfficeProcessor)
      ) {
        this.form.daysToRemindOfficeProcessor = this.maxDaysToRemindOfficeProcessor;
      } else if (
        this.form.daysToRemindOfficeProcessor == "" ||
        parseFloat(this.form.daysToRemindOfficeProcessor) < 0
      ) {
        this.form.daysToRemindOfficeProcessor = 0;
      }
    },
    easeOfDoingBusinessLabel({ option }) {
      return `${option}`;
    },
    selecteaseOfDoingBusiness() {
      this.form.easeOfDoingBusinessType =
        this.easeOfDoingBusiness.easeOfDoingBusinessType != "Others"
          ? this.easeOfDoingBusiness.easeOfDoingBusinessType
          : "";
      this.form.estimatedWorkingDays = this.easeOfDoingBusiness.estimatedWorkingDays;
      this.form.daysToRemindOfficeProcessor = this.easeOfDoingBusiness.daysToRemindOfficeProcessor;
      this.$forceUpdate();
    },
    printSingleTrackingReport(id) {
      var apiUrl = `dts/api/Report/Tracking`;
      var routeVariables = [];
      var body = [];
      body.push({ id: id });
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body
      });
      this.$bvModal.show("print-options-modal");
    }
  }
};
</script>
<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <!-- Create Process Type -->
    <b-modal
      id="modal-create-processType"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <form
        @submit.prevent="onAddProcessType"
        class="needs-validation"
        ref="targetForm"
      >
        <div class="mb-3">
          <label for="processName">Name </label>
          <input
            id="processName"
            type="text"
            v-model="form.processName"
            placeholder="Enter Name..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.processName.$error
            }"
            autocomplete="off"
          />
          <div
            v-if="submitted && $v.form.processName.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.processName.required"
              >This value is required.</span
            >
          </div>
        </div>
        <div class="mb-3">
          <label for="easeOfDoingBusinessType">Ease of Doing Business </label>
          <multiselect
            id="easeOfDoingBusinessType"
            v-model="easeOfDoingBusiness"
            track-by="option"
            label="option"
            placeholder="Select Action Request/Purpose..."
            :custom-label="easeOfDoingBusinessLabel"
            :show-labels="false"
            :options="easeOfDoingBusinessOptions"
            :searchable="false"
            :multiple="false"
            :allow-empty="false"
            :close-on-select="true"
            @input="selecteaseOfDoingBusiness"
            :class="{
              'is-invalid': submitted && $v.form.easeOfDoingBusinessType.$error
            }"
          >
          </multiselect>
          <b-collapse
            :visible="
              easeOfDoingBusiness && easeOfDoingBusiness.option == 'Others'
            "
          >
            <div
              v-if="
                easeOfDoingBusiness && easeOfDoingBusiness.option == 'Others'
              "
              class="mx-3 mt-2"
            >
              <input
                id="easeOfDoingBusinessType"
                type="text"
                v-model="form.easeOfDoingBusinessType"
                placeholder="Enter Ease of Doing Business..."
                class="form-control"
                :class="{
                  'is-invalid':
                    submitted && $v.form.easeOfDoingBusinessType.$error
                }"
                autocomplete="off"
              />
            </div>
          </b-collapse>
          <div
            v-if="submitted && $v.form.easeOfDoingBusinessType.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.easeOfDoingBusinessType.required"
              >This value is required.</span
            >
          </div>
        </div>

        <b-collapse :visible="easeOfDoingBusiness != null">
          <div v-if="easeOfDoingBusiness != null">
            <div class="mb-3">
              <label for="estimatedWorkingDays">Estimated Working Days </label>
              <masked-input
                :mask="quantityMask"
                id="estimatedWorkingDays"
                type="text"
                v-model="form.estimatedWorkingDays"
                placeholder="Enter Estimated Working Days..."
                class="form-control"
                :class="{
                  'is-invalid': submitted && $v.form.estimatedWorkingDays.$error
                }"
                autocomplete="off"
              ></masked-input>
              <div
                v-if="submitted && $v.form.estimatedWorkingDays.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.estimatedWorkingDays.required"
                  >This value is required.</span
                >
              </div>
            </div>
            <div class="mb-3">
              <label for="daysToRemindOfficeProcessor"
                >Days to Remind Office Processor
              </label>
              <masked-input
                :mask="quantityMask"
                id="daysToRemindOfficeProcessor"
                type="text"
                v-model="form.daysToRemindOfficeProcessor"
                placeholder="Enter Days to Remind Office Processor..."
                class="form-control"
                :class="{
                  'is-invalid':
                    submitted && $v.form.daysToRemindOfficeProcessor.$error
                }"
                autocomplete="off"
              ></masked-input>
              <div
                v-if="submitted && $v.form.daysToRemindOfficeProcessor.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.daysToRemindOfficeProcessor.required"
                  >This value is required.</span
                >
              </div>
            </div>
          </div>
        </b-collapse>
        <div class="d-flex float-end">
          <button type="submit" class="btn btn-primary">Submit</button>
        </div>
      </form>
    </b-modal>
    <!-- Create Process Subtype -->
    <b-modal
      id="modal-create-processSubtype"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <form
        @submit.prevent="onAddProcessSubtype"
        class="needs-validation"
        ref="targetForm"
      >
        <div class="mb-3">
          <label for="processName">Name </label>
          <input
            id="processName"
            type="text"
            v-model="form.processName"
            placeholder="Enter Name..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.processName.$error
            }"
            autocomplete="off"
          />
          <div
            v-if="submitted && $v.form.processName.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.processName.required"
              >This value is required.</span
            >
          </div>
        </div>
        <div class="mb-3">
          <label for="estimatedWorkingDays">Estimated Working Days </label>
          <input
            id="estimatedWorkingDays"
            @input="checkEstimatedWorkingDays()"
            type="number"
            v-model="form.estimatedWorkingDays"
            :max="maxEstimatedWorkingDays"
            min="1"
            placeholder="Enter Estimated Working Days..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.estimatedWorkingDays.$error
            }"
            autocomplete="off"
          />
          <div
            v-if="submitted && $v.form.estimatedWorkingDays.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.estimatedWorkingDays.required"
              >This value is required.</span
            >
          </div>
        </div>
        <div class="mb-3">
          <label for="daysToRemindOfficeProcessor"
            >Days to Remind Office Processor
          </label>
          <input
            id="daysToRemindOfficeProcessor"
            @input="checkDaysToRemindOfficeProcessor()"
            type="number"
            v-model="form.daysToRemindOfficeProcessor"
            :max="maxDaysToRemindOfficeProcessor"
            min="1"
            placeholder="Enter Days to Remind Office Processor..."
            class="form-control"
            :class="{
              'is-invalid':
                submitted && $v.form.daysToRemindOfficeProcessor.$error
            }"
            autocomplete="off"
          />
          <div
            v-if="submitted && $v.form.daysToRemindOfficeProcessor.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.daysToRemindOfficeProcessor.required"
              >This value is required.</span
            >
          </div>
        </div>
        <div class="d-flex float-end">
          <button type="submit" class="btn btn-primary">Submit</button>
        </div>
      </form>
    </b-modal>
    <!-- Main -->

    <carousel
      ref="carousel"
      class="events navs-carousel"
      id="timeline-carousel"
      :navigation-enabled="false"
      :pagination-enabled="false"
      :perPage="1"
      :autoplay="false"
      :minSwipeDistance="0"
      :mouseDrag="false"
    >
      <slide class="ps-2">
        <div v-if="slideIndex == 0">
          <div class="py-2" style="min-width: 950px">
            <div class="d-flex flex-row-reverse mb-3">
              <div class="d-flex align-items-center">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-input
                      autocomplete="off"
                      v-model="filter"
                      type="search"
                      placeholder="Search Process Type..."
                      class="form-control"
                    ></b-form-input>
                  </label>
                </div>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-select
                      class="form-select"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    >
                    </b-form-select>
                  </label>
                </div>
              </div>
            </div>
            <b-card v-if="loading">
              <div class="d-flex align-items-center justify-content-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-25px h-25px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
            </b-card>
            <b-card class="text-center" v-else-if="paginated.length == 0">
              <div v-if="filter != ''">
                <i class="fas fa-exclamation-triangle me-2"></i>There are no
                items matching your request
              </div>
              <div v-else>
                <i class="fas fa-exclamation-triangle me-2"></i>No items
                available
              </div>
            </b-card>
            <div v-else class="text-muted">
              <b-card no-body class="m-0 mb-3">
                <b-card-header>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div>
                      <b>Process Type</b>
                    </div>
                    <div class="d-flex align-items-center">
                      <div style="width: 300px">
                        <b>Ease of Doing Business</b>
                      </div>
                      <div style="width: 200px">
                        <b>Duration</b>
                      </div>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
              <div role="tablist" v-for="(x, xIndex) in paginated" :key="x.id">
                <div class="position-relative ms-1">
                  <RawData
                    :data="x"
                    v-if="$store.state.decrypt.isAdmin()"
                    :style="`z-index: ${paginated.length - xIndex + 11}`"
                  />
                </div>
                <b-card
                  no-body
                  class="m-0 mb-3 py-1"
                  :style="`z-index: ${paginated.length - xIndex + 10}`"
                >
                  <b-card-header>
                    <div class="d-flex justify-content-between">
                      <div>
                        <div>{{ x.processName }}</div>
                        <div class="d-flex align-items-center">
                          <div
                            v-if="x.isAssigned"
                            class="d-flex align-items-center"
                          >
                            <small
                              ><a
                                href="javascript: void(0);"
                                @click="showTracks(x)"
                              >
                                Show Tracks
                              </a>
                            </small>
                            <span class="mx-2">|</span>
                          </div>
                          <div>
                            <small>
                              <a
                                href="javascript: void(0);"
                                class="text-success d-flex align-items-center"
                                @click="
                                  x.showSubtype = !x.showSubtype;
                                  $forceUpdate();
                                "
                              >
                                {{ x.showSubtype ? "Hide" : "Show" }}
                                Subtype
                                <i
                                  class="bx bx-chevron-right rotate font-size-14"
                                  :class="{
                                    'rotate-90': x.showSubtype
                                  }"
                                ></i>
                              </a>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex">
                        <div style="width: 300px">
                          {{ x.easeOfDoingBusinessType }}
                        </div>
                        <div style="width: 200px">
                          <small
                            >Estimated Working Days:
                            <b class="text-info">{{
                              x.estimatedWorkingDays
                            }}</b></small
                          >
                          <br />
                          <small
                            >Days to Remind Processor:
                            <b class="text-warning">{{
                              x.daysToRemindOfficeProcessor
                            }}</b></small
                          >
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                </b-card>
                <b-collapse :visible="x.showSubtype">
                  <div v-if="x.showSubtype" class="ps-5">
                    <div
                      class="d-flex justify-content-between align-items-center pb-2"
                    >
                      <b>Process Subtypes</b>
                    </div>
                    <div v-if="!x.childProcessTypes">
                      <i class="font-size-11">No Subtypes Available</i>
                    </div>
                    <div
                      role="tablist"
                      class=""
                      v-for="(y, yIndex) in x.childProcessTypes"
                      :key="y.id"
                    >
                      <div class="position-relative ms-1">
                        <RawData
                          :data="y"
                          v-if="$store.state.decrypt.isAdmin()"
                          :style="`z-index: ${paginated.length - yIndex + 11}`"
                        />
                      </div>
                      <b-card
                        no-body
                        class="m-0 mb-3 py-1"
                        :style="`z-index: ${paginated.length - yIndex + 10}`"
                      >
                        <b-card-header>
                          <div class="d-flex justify-content-between">
                            <div>
                              <div>{{ y.processName }}</div>
                              <div class="d-flex align-items-center">
                                <div>
                                  <small
                                    ><a
                                      href="javascript: void(0);"
                                      @click="showTracks(x)"
                                    >
                                      Show Tracks
                                    </a>
                                  </small>
                                </div>
                              </div>
                            </div>
                            <div class="d-flex">
                              <div style="width: 300px">
                                {{ y.easeOfDoingBusinessType }}
                              </div>
                              <div style="width: 200px">
                                <small
                                  >Estimated Working Days:
                                  <b class="text-info">{{
                                    y.estimatedWorkingDays
                                  }}</b></small
                                >
                                <br />
                                <small
                                  >Days to Remind Processor:
                                  <b class="text-warning">{{
                                    y.daysToRemindOfficeProcessor
                                  }}</b></small
                                >
                              </div>
                            </div>
                          </div>
                        </b-card-header>
                      </b-card>
                    </div>
                    <hr />
                  </div>
                </b-collapse>
              </div>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                  >
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </slide>
      <slide class="ps-2">
        <div v-if="slideIndex == 1">
          <div class="py-2" style="min-width: 950px">
            <div class="d-flex justify-content-between mb-3">
              <div class="d-flex align-items-center h-100">
                <a
                  href="javascript:void(0);"
                  class="d-flex align-items-center"
                  @click="returnToTable()"
                  ><i class="bx bx-left-arrow-alt fs-2 me-1"></i>
                  <h5 class="m-0">Track List</h5></a
                >
              </div>
              <div class="d-flex align-items-center">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-input
                      autocomplete="off"
                      v-model="filter"
                      type="search"
                      placeholder="Search Track..."
                      class="form-control"
                    ></b-form-input>
                  </label>
                </div>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    <b-form-select
                      class="form-select"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    >
                    </b-form-select>
                  </label>
                </div>
              </div>
            </div>
            <b-card v-if="loading">
              <div class="d-flex align-items-center justify-content-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-25px h-25px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
            </b-card>
            <b-card class="text-center" v-else-if="paginated.length == 0">
              <div v-if="filter != ''">
                <i class="fas fa-exclamation-triangle me-2"></i>There are no
                items matching your request
              </div>
              <div v-else>
                <i class="fas fa-exclamation-triangle me-2"></i>No items
                available
              </div>
            </b-card>
            <div v-else class="text-muted">
              <b-card no-body class="m-0 mb-3">
                <b-card-header>
                  <div class="row align-items-center">
                    <div class="col-8">
                      <b>Process Track</b>
                    </div>
                    <div class="col-2">
                      <b>Action Request</b>
                    </div>
                    <div class="col-2">
                      <b>Status</b>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
              <div role="tablist" v-for="(x, index) in paginated" :key="x.id">
                <div class="position-relative ms-1">
                  <RawData
                    :data="x"
                    v-if="$store.state.decrypt.isAdmin()"
                    :style="`z-index: ${paginated.length - index + 11}`"
                  />
                </div>
                <b-card
                  no-body
                  class="m-0 mb-3 py-1"
                  :style="`z-index: ${paginated.length - index + 10}`"
                >
                  <b-card-header>
                    <div class="row">
                      <div class="col-8">
                        <div>{{ x.referenceNumber }}</div>
                        <b class="text-white">{{ x.title }}</b>
                        <div class="d-flex align-items-center">
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-info"
                                @click="viewDetails(x.id)"
                              >
                                View Details
                              </a>
                            </small>
                          </div>
                          <span class="mx-2">|</span>
                          <div>
                            <small
                              ><a
                                href="javascript: void(0);"
                                class="text-warning"
                                @click="viewLogs(x.id)"
                              >
                                View Logs
                              </a>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-2">
                        {{ x.actionNeeded }}
                      </div>
                      <div class="col-2">
                        <div v-if="x.status == 'DRAFT'">
                          <span class="text-info">CREATED</span> on
                          {{ formatDateWithTime(new Date(x.dateTimeCreated)) }}
                        </div>
                        <div v-if="x.status == 'PENDING'">
                          <div>
                            <span class="text-info">SENT</span> on
                            {{ formatDate(new Date(x.dateTimePosted)) }}
                          </div>
                        </div>
                        <div v-if="x.status == 'RETURNED'">
                          <span class="text-warning">{{ x.status }}</span>
                          on
                          {{ formatDate(new Date(x.dateTimePosted)) }}
                        </div>
                        <div v-if="x.status == 'RECEIVED'">
                          <span class="text-pink">{{ x.status }}</span>
                          on
                          {{ formatDate(new Date(x.dateTimeReceived)) }}
                        </div>
                        <div v-if="x.status == 'COMPLETED'">
                          <span class="text-success">PROCESSED</span> on
                          {{ formatDateWithTime(new Date(x.actionDateTime)) }}
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                </b-card>
              </div>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                  >
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </slide>
    </carousel>
    <!--
    <b-tabs
      pills
      vertical
      v-model="tabIndex"
      nav-class="p-0"
      nav-wrapper-class="col-sm-2"
      content-class="pt-0 px-2 text-muted"
    >
      <b-tab
        title-item-class="mb-2"
        @click="
          getAssignedProcessType();
          filter = '';
          currentPage = 1;
        "
      >
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-file"></i>
          </span>
          <span class="d-none d-sm-inline-block">Assigned Process Type</span>
        </template>
        <div v-if="tabIndex == 0">
          <carousel
            ref="carousel"
            class="events navs-carousel"
            id="timeline-carousel"
            :navigation-enabled="false"
            :pagination-enabled="false"
            :perPage="1"
            :autoplay="false"
            :minSwipeDistance="0"
            :mouseDrag="false"
          >
            <slide>
              <div v-if="slideIndex == 0">
                <div class="py-2" style="min-width: 950px">
                  <div class="d-flex flex-row-reverse mb-3">
                    <div class="d-flex align-items-center">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter me-1"
                      >
                        <label class="d-inline-flex align-items-center mb-0">
                          <b-form-input
                            autocomplete="off"
                            v-model="filter"
                            type="search"
                            placeholder="Search Process Type..."
                            class="form-control"
                          ></b-form-input>
                        </label>
                      </div>
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center mb-0">
                          <b-form-select
                            class="form-select"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                          >
                          </b-form-select>
                        </label>
                      </div>
                    </div>
                  </div>
                  <b-card v-if="loading">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      <div class="preloader-component me-2">
                        <div class="status">
                          <div class="spinner-chase w-25px h-25px">
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                          </div>
                        </div>
                      </div>
                      <h5 class="mb-0">Loading...</h5>
                    </div>
                  </b-card>
                  <b-card class="text-center" v-else-if="paginated.length == 0">
                    <div v-if="filter != ''">
                      <i class="fas fa-exclamation-triangle me-2"></i>There are
                      no items matching your request
                    </div>
                    <div v-else>
                      <i class="fas fa-exclamation-triangle me-2"></i>No items
                      available
                    </div>
                  </b-card>
                  <div v-else class="text-muted">
                    <b-card no-body class="m-0 mb-3">
                      <b-card-header>
                        <div
                          class="d-flex align-items-center justify-content-between"
                        >
                          <div>
                            <b>Process Type</b>
                          </div>
                          <div class="d-flex align-items-center">
                            <div style="width: 300px">
                              <b>Ease of Doing Business</b>
                            </div>
                            <div style="width: 200px">
                              <b>Duration</b>
                            </div>
                          </div>
                        </div>
                      </b-card-header>
                    </b-card>
                    <div
                      role="tablist"
                      v-for="(x, xIndex) in paginated"
                      :key="x.id"
                    >
                      <div class="position-relative ms-1">
                        <RawData
                          :data="x"
                          v-if="$store.state.decrypt.isAdmin()"
                          :style="`z-index: ${paginated.length - xIndex + 11}`"
                        />
                      </div>
                      <b-card
                        no-body
                        class="m-0 mb-3 py-1"
                        :style="`z-index: ${paginated.length - xIndex + 10}`"
                      >
                        <b-card-header>
                          <div class="d-flex justify-content-between">
                            <div>
                              <div>{{ x.processName }}</div>
                              <div class="d-flex align-items-center">
                                <div
                                  v-if="x.isAssigned"
                                  class="d-flex align-items-center"
                                >
                                  <small
                                    ><a
                                      href="javascript: void(0);"
                                      @click="showTracks(x)"
                                    >
                                      Show Tracks
                                    </a>
                                  </small>
                                  <span class="mx-2">|</span>
                                </div>
                                <div>
                                  <small>
                                    <a
                                      href="javascript: void(0);"
                                      class="text-success d-flex align-items-center"
                                      @click="
                                        x.showSubtype = !x.showSubtype;
                                        $forceUpdate();
                                      "
                                    >
                                      {{ x.showSubtype ? "Hide" : "Show" }}
                                      Subtype
                                      <i
                                        class="bx bx-chevron-right rotate font-size-14"
                                        :class="{
                                          'rotate-90': x.showSubtype,
                                        }"
                                      ></i>
                                    </a>
                                  </small>
                                </div>
                              </div>
                            </div>
                            <div class="d-flex">
                              <div style="width: 300px">
                                {{ x.easeOfDoingBusinessType }}
                              </div>
                              <div style="width: 200px">
                                <small
                                  >Estimated Working Days:
                                  <b class="text-info">{{
                                    x.estimatedWorkingDays
                                  }}</b></small
                                >
                                <br />
                                <small
                                  >Days to Remind Processor:
                                  <b class="text-warning">{{
                                    x.daysToRemindOfficeProcessor
                                  }}</b></small
                                >
                              </div>
                            </div>
                          </div>
                        </b-card-header>
                      </b-card>
                      <b-collapse :visible="x.showSubtype">
                        <div v-if="x.showSubtype" class="ps-5">
                          <div
                            class="d-flex justify-content-between align-items-center pb-2"
                          >
                            <b>Process Subtypes</b>
                          </div>
                          <div v-if="!x.childProcessTypes">
                            <i class="font-size-11">No Subtypes Available</i>
                          </div>
                          <div
                            role="tablist"
                            class=""
                            v-for="(y, yIndex) in x.childProcessTypes"
                            :key="y.id"
                          >
                            <div class="position-relative ms-1">
                              <RawData
                                :data="y"
                                v-if="$store.state.decrypt.isAdmin()"
                                :style="`z-index: ${
                                  paginated.length - yIndex + 11
                                }`"
                              />
                            </div>
                            <b-card
                              no-body
                              class="m-0 mb-3 py-1"
                              :style="`z-index: ${
                                paginated.length - yIndex + 10
                              }`"
                            >
                              <b-card-header>
                                <div class="d-flex justify-content-between">
                                  <div>
                                    <div>{{ y.processName }}</div>
                                    <div class="d-flex align-items-center">
                                      <div>
                                        <small
                                          ><a
                                            href="javascript: void(0);"
                                            @click="showTracks(x)"
                                          >
                                            Show Tracks
                                          </a>
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="d-flex">
                                    <div style="width: 300px">
                                      {{ y.easeOfDoingBusinessType }}
                                    </div>
                                    <div style="width: 200px">
                                      <small
                                        >Estimated Working Days:
                                        <b class="text-info">{{
                                          y.estimatedWorkingDays
                                        }}</b></small
                                      >
                                      <br />
                                      <small
                                        >Days to Remind Processor:
                                        <b class="text-warning">{{
                                          y.daysToRemindOfficeProcessor
                                        }}</b></small
                                      >
                                    </div>
                                  </div>
                                </div>
                              </b-card-header>
                            </b-card>
                          </div>
                          <hr />
                        </div>
                      </b-collapse>
                    </div>
                  </div>
                  <div class="row">
                    <div v-if="rows > 0" class="col">
                      Showing {{ (currentPage - 1) * perPage + 1 }} -
                      {{
                        rows > (currentPage - 1) * perPage + perPage
                          ? (currentPage - 1) * perPage + perPage
                          : rows
                      }}
                      of {{ rows }}
                    </div>
                    <div class="col">
                      <div
                        class="dataTables_paginate paging_simple_numbers float-end"
                      >
                        <ul
                          class="pagination pagination-rounded mb-0"
                          style="z-index: -1"
                        >
                          <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                          ></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </slide>
            <slide>
              <div v-if="slideIndex == 1">
                <div class="py-2" style="min-width: 950px">
                  <div class="d-flex justify-content-between mb-3">
                    <div class="d-flex align-items-center h-100">
                      <a
                        href="javascript:void(0);"
                        class="d-flex align-items-center"
                        @click="returnToTable()"
                        ><i class="bx bx-left-arrow-alt fs-2 me-1"></i>
                        <h5 class="m-0">Track List</h5></a
                      >
                    </div>
                    <div class="d-flex align-items-center">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter me-1"
                      >
                        <label class="d-inline-flex align-items-center mb-0">
                          <b-form-input
                            autocomplete="off"
                            v-model="filter"
                            type="search"
                            placeholder="Search Track..."
                            class="form-control"
                          ></b-form-input>
                        </label>
                      </div>
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center mb-0">
                          <b-form-select
                            class="form-select"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                          >
                          </b-form-select>
                        </label>
                      </div>
                    </div>
                  </div>
                  <b-card v-if="loading">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      <div class="preloader-component me-2">
                        <div class="status">
                          <div class="spinner-chase w-25px h-25px">
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                          </div>
                        </div>
                      </div>
                      <h5 class="mb-0">Loading...</h5>
                    </div>
                  </b-card>
                  <b-card class="text-center" v-else-if="paginated.length == 0">
                    <div v-if="filter != ''">
                      <i class="fas fa-exclamation-triangle me-2"></i>There are
                      no items matching your request
                    </div>
                    <div v-else>
                      <i class="fas fa-exclamation-triangle me-2"></i>No items
                      available
                    </div>
                  </b-card>
                  <div v-else class="text-muted">
                    <b-card no-body class="m-0 mb-3">
                      <b-card-header>
                        <div class="row align-items-center">
                          <div class="col-8">
                            <b>Process Track</b>
                          </div>
                          <div class="col-2">
                            <b>Action Request</b>
                          </div>
                          <div class="col-2">
                            <b>Status</b>
                          </div>
                        </div>
                      </b-card-header>
                    </b-card>
                    <div
                      role="tablist"
                      v-for="(x, index) in paginated"
                      :key="x.id"
                    >
                      <div class="position-relative ms-1">
                        <RawData
                          :data="x"
                          v-if="$store.state.decrypt.isAdmin()"
                          :style="`z-index: ${paginated.length - index + 11}`"
                        />
                      </div>
                      <b-card
                        no-body
                        class="m-0 mb-3 py-1"
                        :style="`z-index: ${paginated.length - index + 10}`"
                      >
                        <b-card-header>
                          <div class="row">
                            <div class="col-8">
                              <div>{{ x.referenceNumber }}</div>
                              <b class="text-white">{{ x.title }}</b>
                              <div class="d-flex align-items-center">
                                <div>
                                  <small
                                    ><a
                                      href="javascript: void(0);"
                                      class="text-info"
                                      @click="viewDetails(x.id)"
                                    >
                                      View Details
                                    </a>
                                  </small>
                                </div>
                                <span class="mx-2">|</span>
                                <div>
                                  <small
                                    ><a
                                      href="javascript: void(0);"
                                      class="text-warning"
                                      @click="viewLogs(x.id)"
                                    >
                                      View Logs
                                    </a>
                                  </small>
                                </div>
                              </div>
                            </div>
                            <div class="col-2">
                              {{ x.actionNeeded }}
                            </div>
                            <div class="col-2">
                              <div v-if="x.status == 'DRAFT'">
                                <span class="text-info">CREATED</span> on
                                {{
                                  formatDateWithTime(
                                    new Date(x.dateTimeCreated)
                                  )
                                }}
                              </div>
                              <div v-if="x.status == 'PENDING'">
                                <div>
                                  <span class="text-info">SENT</span> on
                                  {{ formatDate(new Date(x.dateTimePosted)) }}
                                </div>
                              </div>
                              <div v-if="x.status == 'RETURNED'">
                                <span class="text-warning">{{ x.status }}</span>
                                on
                                {{ formatDate(new Date(x.dateTimePosted)) }}
                              </div>
                              <div v-if="x.status == 'RECEIVED'">
                                <span class="text-pink">{{ x.status }}</span>
                                on
                                {{ formatDate(new Date(x.dateTimeReceived)) }}
                              </div>
                              <div v-if="x.status == 'COMPLETED'">
                                <span class="text-success">PROCESSED</span> on
                                {{
                                  formatDateWithTime(new Date(x.actionDateTime))
                                }}
                              </div>
                            </div>
                          </div>
                        </b-card-header>
                      </b-card>
                    </div>
                  </div>
                  <div class="row">
                    <div v-if="rows > 0" class="col">
                      Showing {{ (currentPage - 1) * perPage + 1 }} -
                      {{
                        rows > (currentPage - 1) * perPage + perPage
                          ? (currentPage - 1) * perPage + perPage
                          : rows
                      }}
                      of {{ rows }}
                    </div>
                    <div class="col">
                      <div
                        class="dataTables_paginate paging_simple_numbers float-end"
                      >
                        <ul
                          class="pagination pagination-rounded mb-0"
                          style="z-index: -1"
                        >
                          <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                          ></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </b-tab>
      <b-tab
        title-item-class="mb-2"
        @click="
          getMyProcessType();
          filter = '';
          currentPage = 1;
        "
      >
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-home"></i>
          </span>
          <span class="d-none d-sm-inline-block">My Process Type</span>
        </template>
        <div v-if="tabIndex == 1">
          <carousel
            ref="carousel"
            class="events navs-carousel"
            id="timeline-carousel"
            :navigation-enabled="false"
            :pagination-enabled="false"
            :perPage="1"
            :autoplay="false"
            :minSwipeDistance="0"
            :mouseDrag="false"
          >
            <slide>
              <div class="py-2" style="min-width: 950px">
                <div class="d-flex flex-row-reverse mb-2">
                  <button
                    type="button"
                    @click="addProcessType()"
                    class="btn btn-sm btn-success d-flex align-items-center ms-1"
                  >
                    <i class="bx bx-plus fs-6 me-1"></i>Create Process Type
                  </button>
                </div>
                <div class="d-flex flex-row-reverse mb-3">
                  <div class="d-flex align-items-center">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter me-1"
                    >
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-input
                          autocomplete="off"
                          v-model="filter"
                          type="search"
                          placeholder="Search Process Type..."
                          class="form-control"
                        ></b-form-input>
                      </label>
                    </div>
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-select
                          class="form-select"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        >
                        </b-form-select>
                      </label>
                    </div>
                  </div>
                </div>
                <b-card v-if="loading">
                  <div class="d-flex align-items-center justify-content-center">
                    <div class="preloader-component me-2">
                      <div class="status">
                        <div class="spinner-chase w-25px h-25px">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                    <h5 class="mb-0">Loading...</h5>
                  </div>
                </b-card>
                <b-card class="text-center" v-else-if="paginated.length == 0">
                  <div v-if="filter != ''">
                    <i class="fas fa-exclamation-triangle me-2"></i>There are no
                    items matching your request
                  </div>
                  <div v-else>
                    <i class="fas fa-exclamation-triangle me-2"></i>No items
                    available
                  </div>
                </b-card>
                <div v-else class="text-muted">
                  <b-card no-body class="m-0 mb-3">
                    <b-card-header>
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <div>
                          <b>Process Type</b>
                        </div>
                        <div class="d-flex align-items-center">
                          <div style="width: 300px">
                            <b>Ease of Doing Business</b>
                          </div>
                          <div style="width: 200px">
                            <b>Duration</b>
                          </div>
                          <div style="width: 60px">
                            <b>Actions</b>
                          </div>
                        </div>
                      </div>
                    </b-card-header>
                  </b-card>
                  <div
                    role="tablist"
                    v-for="(x, xIndex) in paginated"
                    :key="x.id"
                  >
                    <div class="position-relative ms-1">
                      <RawData
                        :data="x"
                        v-if="$store.state.decrypt.isAdmin()"
                        :style="`z-index: ${paginated.length - xIndex + 11}`"
                      />
                    </div>
                    <b-card
                      no-body
                      class="m-0 mb-3 py-1"
                      :style="`z-index: ${paginated.length - xIndex + 10}`"
                    >
                      <b-card-header>
                        <div class="d-flex justify-content-between">
                          <div>
                            <div>{{ x.processName }}</div>
                            <div class="d-flex align-items-center">
                              <div>
                                <small>
                                  <a
                                    href="javascript: void(0);"
                                    class="text-success d-flex align-items-center"
                                    @click="
                                      x.showSubtype = !x.showSubtype;
                                      $forceUpdate();
                                    "
                                  >
                                    {{ x.showSubtype ? "Hide" : "Show" }}
                                    Subtype
                                    <i
                                      class="bx bx-chevron-right rotate font-size-14"
                                      :class="{
                                        'rotate-90': x.showSubtype,
                                      }"
                                    ></i>
                                  </a>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="d-flex">
                            <div style="width: 300px">
                              {{ x.easeOfDoingBusinessType }}
                            </div>
                            <div style="width: 200px">
                              <small
                                >Estimated Working Days:
                                <b class="text-info">{{
                                  x.estimatedWorkingDays
                                }}</b></small
                              >
                              <br />
                              <small
                                >Days to Remind Processor:
                                <b class="text-warning">{{
                                  x.daysToRemindOfficeProcessor
                                }}</b></small
                              >
                            </div>
                            <div style="width: 60px">
                              <div class="d-flex justify-content-end">
                                <i
                                  class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                                  :id="`type-popover-${x.id}`"
                                  tabindex="0"
                                ></i>
                                <b-popover
                                  :target="`type-popover-${x.id}`"
                                  triggers="click blur"
                                  placement="leftbottom"
                                  variant="secondary"
                                  custom-class="p-0"
                                >
                                  <b-list-group class="w-100 fit">
                                    <b-list-group-item
                                      button
                                      action
                                      class="d-flex align-items-center text-info"
                                      @click="updateProcessType(x)"
                                      ><i
                                        class="bx bx-edit font-size-18 me-1"
                                      ></i
                                      >Update Process Type</b-list-group-item
                                    >
                                    <b-list-group-item
                                      v-if="
                                        !x.childProcessTypes ||
                                        x.childProcessTypes.length == 0
                                      "
                                      button
                                      action
                                      class="d-flex align-items-center text-danger"
                                      @click="deleteProcessType(x)"
                                      ><i
                                        class="bx bx-trash font-size-18 me-1"
                                      ></i
                                      >Delete Process Type</b-list-group-item
                                    >
                                  </b-list-group>
                                </b-popover>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card-header>
                    </b-card>
                    <b-collapse :visible="x.showSubtype">
                      <div v-if="x.showSubtype" class="ps-5">
                        <div
                          class="d-flex justify-content-between align-items-center pb-2"
                        >
                          <b>Process Subtypes</b>
                          <button
                            type="button"
                            @click="addProcessSubtype(x)"
                            class="btn btn-sm btn-success d-flex align-items-center ms-1"
                          >
                            <i class="bx bx-plus fs-6 me-1"></i>Create Process
                            Subtype
                          </button>
                        </div>
                        <div v-if="!x.childProcessTypes">
                          <i class="font-size-11">No Subtypes Available</i>
                        </div>
                        <div
                          role="tablist"
                          class=""
                          v-for="(y, yIndex) in x.childProcessTypes"
                          :key="y.id"
                        >
                          <div class="position-relative ms-1">
                            <RawData
                              :data="y"
                              v-if="$store.state.decrypt.isAdmin()"
                              :style="`z-index: ${
                                paginated.length - yIndex + 11
                              }`"
                            />
                          </div>
                          <b-card
                            no-body
                            class="m-0 mb-3 py-1"
                            :style="`z-index: ${
                              paginated.length - yIndex + 10
                            }`"
                          >
                            <b-card-header>
                              <div class="d-flex justify-content-between">
                                <div>
                                  <div>{{ y.processName }}</div>
                                  <div class="d-flex align-items-center">
                                    <div>
                                      <small
                                        ><a
                                          href="javascript: void(0);"
                                          class="text-pink"
                                          @click="manageOffices(y)"
                                        >
                                          Manage Offices
                                        </a>
                                      </small>
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex">
                                  <div style="width: 300px">
                                    {{ y.easeOfDoingBusinessType }}
                                  </div>
                                  <div style="width: 200px">
                                    <small
                                      >Estimated Working Days:
                                      <b class="text-info">{{
                                        y.estimatedWorkingDays
                                      }}</b></small
                                    >
                                    <br />
                                    <small
                                      >Days to Remind Processor:
                                      <b class="text-warning">{{
                                        y.daysToRemindOfficeProcessor
                                      }}</b></small
                                    >
                                  </div>
                                  <div style="width: 60px">
                                    <div class="d-flex justify-content-end">
                                      <i
                                        class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                                        :id="`subtype-popover-${x.id}-${y.id}`"
                                        tabindex="0"
                                      ></i>
                                      <b-popover
                                        :target="`subtype-popover-${x.id}-${y.id}`"
                                        triggers="click blur"
                                        placement="leftbottom"
                                        variant="secondary"
                                        custom-class="p-0"
                                      >
                                        <b-list-group class="w-100 fit">
                                          <b-list-group-item
                                            button
                                            action
                                            class="d-flex align-items-center text-info"
                                            @click="updateProcessSubtype(y, x)"
                                            ><i
                                              class="bx bx-edit font-size-18 me-1"
                                            ></i
                                            >Update Process
                                            Subtype</b-list-group-item
                                          >
                                          <b-list-group-item
                                            button
                                            action
                                            class="d-flex align-items-center text-danger"
                                            @click="deleteProcessType(y, x)"
                                            ><i
                                              class="bx bx-trash font-size-18 me-1"
                                            ></i
                                            >Delete Process
                                            Subtype</b-list-group-item
                                          >
                                        </b-list-group>
                                      </b-popover>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </b-card-header>
                          </b-card>
                        </div>
                        <hr />
                      </div>
                    </b-collapse>
                  </div>
                </div>
                <div class="row">
                  <div v-if="rows > 0" class="col">
                    Showing {{ (currentPage - 1) * perPage + 1 }} -
                    {{
                      rows > (currentPage - 1) * perPage + perPage
                        ? (currentPage - 1) * perPage + perPage
                        : rows
                    }}
                    of {{ rows }}
                  </div>
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul
                        class="pagination pagination-rounded mb-0"
                        style="z-index: -1"
                      >
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </b-tab>
    </b-tabs>
    -->
    <Details
      user="processType"
      @printTrackingReport="printSingleTrackingReport($event)"
      ref="details"
    ></Details>
    <Logs @viewDetails="viewDetails($event)" ref="logs"></Logs>
    <ManageDu ref="managedu"></ManageDu>
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}
</style>
